import { api } from "./api"

export const GET_COMPANIES_STATISTICS = async (params) => {
    const {data} = await api.get("/statistics/companies", { params })
    return data;
}
